export const LANG = {
  fr: 'Français',
  en: 'English',
}
